import cRowList from './cRowList.vue';

export default {
  install(Vue) {
    Vue.component('cRowList', cRowList);
  },
};
